import apiFetch from '../apiFetch'

export default function (token, rating) {
  return apiFetch({ endPoint: 'Rating', method: 'POST', body: rating, token: token })
}
